import React, { useRef, useState } from 'react'

import { string } from 'prop-types'

import Icon from '../Icon'
import Text from '../Text'
import * as S from './styled'

const Video = ({ youtubeId, poster }) => {
  const [active, setActive] = useState(true)
  const videoRef = useRef(null)

  const _onClick = () => {
    videoRef.current.internalPlayer.playVideo()
    setActive(false)
  }

  const _onEnd = () => {
    setActive(true)
  }

  return (
    <S.VideoWrapper onClick={_onClick}>
      <S.VideoPoster active={active} youtubePoster={poster}>
        <S.VideoPlay className="t-center">
          <Icon name="play" size={60} color="light" />
          <Text marginTop={4} color="light" size={20}>
            Assistir vídeo
          </Text>
        </S.VideoPlay>
      </S.VideoPoster>
      <S.VideoYouTube
        ref={videoRef}
        containerClassName="youtube-container"
        videoId={youtubeId}
        onEnd={_onEnd}
        onPause={_onEnd}
        opts={{
          width: '100%',
          playerVars: {
            modestbranding: 0,
            controls: 0,
            rel: 0,
            autohide: 0,
            showinfo: 0,
          },
          host: 'https://www.youtube-nocookie.com',
        }}
      />
    </S.VideoWrapper>
  )
}

Video.propTypes = {
  youtubeId: string,
  poster: string,
}

export default Video
